import { cn } from "@gymflow/helpers";

import { SearchIcon } from "./icons/SearchIcon";

export type EmptyPageProps = {
  textOverride?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
};

export const EmptyPage = ({
  action,
  textOverride,
  description,
  className,
}: EmptyPageProps) => {
  return (
    <div className={cn("flex max-w-64 flex-col items-center gap-4", className)}>
      <div className="flex size-12 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700">
        <div className="flex size-8 items-center justify-center rounded-full bg-gray-200 dark:bg-gray-600">
          <SearchIcon pathClassName="dark:stroke-gray-200" className="size-6" />
        </div>
      </div>
      <div className="dark:text-gray-0 font-semibold text-gray-950">
        {textOverride ?? "No Matches"}
      </div>
      {description && (
        <div className="text-center text-sm text-gray-500 ">{description}</div>
      )}
      {action}
    </div>
  );
};
